import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';
import { ArrowLeftIcon, ArrowRightIcon } from '@change/ds-icons';

type ScrollButtonsProps = {
	onScrollLeft: () => void;
	onScrollRight: () => void;
	canScrollLeft: boolean;
	canScrollRight: boolean;
};

export function ScrollButtons({
	onScrollLeft,
	onScrollRight,
	canScrollLeft,
	canScrollRight,
}: ScrollButtonsProps): JSX.Element {
	return (
		<div className="ml-auto hidden flex-row gap-3 md:flex" data-testid="scroll-buttons" data-qa="scroll-buttons">
			<Button
				disabled={!canScrollLeft}
				aria-label="Scroll left"
				className="h-9 w-9"
				iconOnly
				leadingIcon={<ArrowLeftIcon className="h-5 w-5" size={20} />}
				onClick={onScrollLeft}
				data-testid="scroll-left-button"
				data-qa="scroll-left-button"
			></Button>
			<Button
				disabled={!canScrollRight}
				aria-label="Scroll right"
				className="h-9 w-9"
				iconOnly
				leadingIcon={<ArrowRightIcon className="h-5 w-5" size={20} />}
				onClick={onScrollRight}
				data-testid="scroll-right-button"
				data-qa="scroll-right-button"
			></Button>
		</div>
	);
}
